import { render, staticRenderFns } from "./MicroscopyQCForm.vue?vue&type=template&id=d60464a4&"
import script from "./MicroscopyQCForm.vue?vue&type=script&lang=js&"
export * from "./MicroscopyQCForm.vue?vue&type=script&lang=js&"
import style0 from "./MicroscopyQCForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports